/**
 * 统一订单地址 resolver（全角色订单详情唯一入口）
 *
 * 语义（2026-08-30 冻结）：
 *   pickup            → pickup_address_snapshot →（仅旧数据无 snapshot）fallback 当前 pickup_address
 *   courier/express   → contact_address（用户收货地址快照）
 *
 * 铁律：
 *   - 两类地址彻底分离，禁止互相 fallback——registered_address（法律主体展示）
 *     与 contact_address（收货地址）都绝不能出现在自提链路，反之亦然。
 *   - pickup 单坐标恒 null：fo 表的 latitude/longitude 是收货地址 geocode 的结果，
 *     自提单必须从取货地址出发重新解析（OrderLocationMap 无坐标自动 geocode，
 *     MapNavButton 无坐标走关键字搜索）——文字/地图/导航三者同一 address 来源。
 *   - pickup 无地址 → address=''：页面显示"暂未配置自提地址"，OrderLocationMap
 *     address 空整体不渲染（地图+导航天然隐藏）。
 *
 * @param {Object} order - 订单对象（fo DTO：fulfillment_mode / pickup_address_snapshot / contact_address / latitude / longitude；
 *                         PC 端 camelCase DTO 的 contactAddress 也兼容）
 * @param {Object} platformConfig - publicConfig 结果（仅需 pickupAddress；snapshot 有值时不依赖）
 * @returns {{label:string, address:string, latitude:number|null, longitude:number|null, isPickup:boolean}}
 */
export function resolveOrderLocation (order, platformConfig) {
  const o = order || {}
  if (o.fulfillment_mode === 'pickup') {
    // 旧数据兼容：snapshot 为 NULL/空才 fallback 当前配置（任务书 §六；新单创建即冻结，不走此分支）
    const addr = String(o.pickup_address_snapshot || '').trim() ||
      String((platformConfig && platformConfig.pickupAddress) || '').trim()
    return { label: '自提地址', address: addr, latitude: null, longitude: null, isPickup: true }
  }
  const addr = String(o.contact_address || o.contactAddress || '').trim()
  return {
    label: '收货地址',
    address: addr,
    latitude: o.latitude != null ? o.latitude : null,
    longitude: o.longitude != null ? o.longitude : null,
    isPickup: false
  }
}
